import React from 'react';
import {useSelector} from 'react-redux';
import {RootState} from '~/redux/root-reducer';
import {PCOS_TEST_KEYS} from '~/constants/medical-questionnaires';
import Questionnaire1Screen from '~/pages/homes/pcos-test/Questionnaire1Screen';
import Questionnaire2Screen from '~/pages/homes/pcos-test/Questionnaire2Screen';
import Questionnaire3Screen from '~/pages/homes/pcos-test/Questionnaire3Screen';
import Questionnaire4Screen from '~/pages/homes/pcos-test/Questionnaire4Screen';
import Questionnaire5Screen from '~/pages/homes/pcos-test/Questionnaire5Screen';
import {trackPageViewGA} from '~/services/google-analytics';

const PCOSTest = () => {
  const activeQuestion = useSelector((state: RootState) => state.questionnaires.activeQuestion);
  const medicalQuestionnaire = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);
  const questionnaires = medicalQuestionnaire?.questionnaires;

  if (!questionnaires?.length) return null;

  const renderQuestion = () => {
    const keys = activeQuestion.keys;
    const key = keys[keys.length - 1];
    switch (key) {
      case PCOS_TEST_KEYS.START:
        trackPageViewGA('/pcos-test/start', 'MDQ-PCOS Test - Start');
        return <Questionnaire1Screen />;
      case PCOS_TEST_KEYS.PROFILE:
        trackPageViewGA('/pcos-test/profile', 'MDQ-PCOS Test - Profile');
        return <Questionnaire2Screen />;
      case PCOS_TEST_KEYS.INVALID:
        trackPageViewGA('/pcos-test/invalid', 'MDQ-PCOS Test - Invalid');
        return <Questionnaire3Screen />;
      case PCOS_TEST_KEYS.APPOINTMENT_PREFERENCES:
        trackPageViewGA('/pcos-test/appointment-preferences', 'MDQ-PCOS Test - Appointment Preferences');
        return <Questionnaire4Screen />;
      case PCOS_TEST_KEYS.YOUR_TEST_PACKAGE:
        trackPageViewGA('/pcos-test/your-test-package', 'MDQ-PCOS Test - Your Test Package');
        return <Questionnaire5Screen />;
      default:
        // eslint-disable-next-line no-console
        console.warn('Not implement yet!');
        return <Questionnaire1Screen />;
    }
  };

  return renderQuestion();
};

export default PCOSTest;
